import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ROUTE_FRAGMENT } from './fragments';

export const MOVE_DELIVERY_STOPS_TO_CUSTOMER_PICKUP = gql`
  ${ROUTE_FRAGMENT}
  mutation ${PRODUCT}MoveDeliveryStopsToCustomerPickup(
    $input: MoveDeliveryStopsToCustomerPickupInput!
  ) {
    moveDeliveryStopsToCustomerPickup(input: $input) {
      updatedRoutes {
        ...RouteFragment
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
